import { FC } from "react";
import { Box, Skeleton, VStack } from "@chakra-ui/react";

export const MainPagePaymentSchedulePending: FC = () => {
  return (
    <Box bg="white" borderRadius="16px" px="20px" py="16px" w="100%">
      <VStack spacing={1} alignItems="flex-start" pt="6px">
        <Skeleton w="100%" h="26px" mb="14px" />
        <Skeleton w="200px" maxW="100%" h="16px" mb="5px" />
        <Skeleton w="100%" h="22px" />
        <Skeleton w="100%" h="52px" mt="22px" borderRadius="18px" />
      </VStack>
    </Box>
  );
};
